// English string -> Italian translation. Keys are the exact English text
// passed to t(). Anything missing here falls back to English (never breaks).
export const it = {
  // Nav / shell
  'Dashboard': 'Dashboard',
  'Companies': 'Aziende',
  'Italy — Funds': 'Italia — Bandi',
  'Funds': 'Bandi',
  'Morocco — Trade': 'Marocco — Commercio',
  'Projects': 'Progetti',
  'Contracts': 'Contratti',
  'Exclusivities': 'Esclusive',
  'Calendar': 'Calendario',
  'Tasks': 'Attività',
  'Assistant': 'Assistente',
  'Account': 'Account',
  'Settings': 'Impostazioni',
  'Users': 'Utenti',
  'Sign out': 'Esci',

  // Common actions
  'Add': 'Aggiungi',
  'Cancel': 'Annulla',
  'Save': 'Salva',
  'Saving…': 'Salvataggio…',
  'Delete': 'Elimina',
  'Edit': 'Modifica',
  'Close': 'Chiudi',
  'Confirm': 'Conferma',
  'Discard': 'Scarta',
  'Keep editing': 'Continua a modificare',
  'Please confirm': 'Conferma richiesta',
  'Discard changes?': 'Scartare le modifiche?',
  'You have unsaved changes. Close this form without saving?': 'Ci sono modifiche non salvate. Chiudere senza salvare?',
  'Previous': 'Precedente',
  'Next': 'Successivo',
  'Page {a} of {b} · {n} total': 'Pagina {a} di {b} · {n} totali',
  'Clear': 'Cancella filtri',
  'Open': 'Apri',
  'View': 'Visualizza',
  'Download': 'Scarica',
  'Upload': 'Carica',
  'Remove': 'Rimuovi',
  'Restore': 'Ripristina',
  'Rename': 'Rinomina',

  // Dashboard
  'Welcome back, {name}': 'Bentornato, {name}',
  '1 overdue task': '1 attività in ritardo',
  '{n} overdue tasks': '{n} attività in ritardo',
  'review them on the Tasks page': 'controllale nella pagina Attività',
  'View tasks': 'Vedi attività',
  '1 assistant action awaiting your approval': "1 azione dell'assistente in attesa di approvazione",
  '{n} assistant actions awaiting your approval': "{n} azioni dell'assistente in attesa di approvazione",
  'Review': 'Rivedi',
  'Active funds': 'Bandi attivi',
  'Fund clients': 'Clienti su bandi',
  'Grants approved': 'Contributi approvati',
  'Active projects': 'Progetti attivi',
  'Open contracts': 'Contratti aperti',
  'Open tasks': 'Attività aperte',
  'Upcoming schedule': 'Prossimi appuntamenti',
  'Full calendar': 'Calendario completo',
  'Projects by country': 'Progetti per paese',
  'Payment milestones due (30 days)': 'Milestone di pagamento in scadenza (30 giorni)',
  'No payment milestones due soon.': 'Nessuna milestone in scadenza a breve.',
  'Tasks due soon': 'Attività in scadenza',
  'All tasks': 'Tutte le attività',
  'Nothing due in the next 7 days': 'Niente in scadenza nei prossimi 7 giorni',
  'Contracts expiring (30 days)': 'Contratti in scadenza (30 giorni)',
  'No contracts expiring soon.': 'Nessun contratto in scadenza a breve.',
  'Assistant activity': "Attività dell'assistente",
  'Actions awaiting approval': 'Azioni in attesa di approvazione',
  'deletes data': 'elimina dati',
  'Requested': 'Richiesta il',
  'Approve': 'Approva',
  'Reject': 'Rifiuta',
  'Recent assistant changes (undo)': "Modifiche recenti dell'assistente (annulla)",
  'undone': 'annullata',
  'Undo': 'Annulla modifica',
  '1 change': '1 modifica',
  '{n} changes': '{n} modifiche',
  'Undo AI changes': "Annulla modifiche dell'assistente",
  'Undo "{label}"? This will revert {n} change(s) made by the assistant.': 'Annullare "{label}"? Verranno annullate {n} modifiche fatte dall\'assistente.',
  'Changes reverted': 'Modifiche annullate',
  'Action approved': 'Azione approvata',
  'Action rejected': 'Azione rifiutata',

  // Tasks
  'List': 'Elenco',
  'Board': 'Bacheca',
  'Timeline': 'Diagramma',
  'New task': 'Nuova attività',
  'All projects': 'Tutti i progetti',
  'All assignees': 'Tutti gli assegnatari',
  'All priorities': 'Tutte le priorità',
  'No tasks match these filters. Create one with the "New task" button.': 'Nessuna attività corrisponde ai filtri. Creane una con "Nuova attività".',
  'No cards': 'Nessuna scheda',
  'Drag to move': 'Trascina per spostare',
  'At a glance': 'In sintesi',
  'Key deadlines from tasks, contracts and funds — open the calendar for the full schedule.':
    'Scadenze chiave da attività, contratti e fondi — apri il calendario per la pianificazione completa.',
  'Contract': 'Contratto',
  'My tasks': 'Le mie attività',
  'Show only tasks assigned to me': 'Mostra solo le attività assegnate a me',
  'No project': 'Nessun progetto',
  'Unassigned': 'Non assegnata',
  '{n} shown': '{n} visualizzate',
  'Notifications': 'Notifiche',
  'Mark all read': 'Segna tutte come lette',
  'No notifications': 'Nessuna notifica',
  'Loading…': 'Caricamento…',
  'Command palette': 'Palette comandi',
  'Search pages, projects, tasks…': 'Cerca pagine, progetti, attività…',
  'Go to': 'Vai a',
  'No results': 'Nessun risultato',
  'navigate': 'naviga',
  'open': 'apri',
  'close': 'chiudi',
  'Search': 'Cerca',
  'Activity': 'Attività',
  'No activity yet.': 'Nessuna attività ancora.',
  'Created': 'Creato',
  'Updated': 'Aggiornato',
  'Deleted': 'Eliminato',
  'Status changed': 'Stato modificato',
  'Bulk update': 'Aggiornamento multiplo',
  'System': 'Sistema',
  'Export Excel': 'Esporta Excel',
  'Exporting…': 'Esportazione…',
  'Export ready': 'Esportazione pronta',
  'Export failed': 'Esportazione non riuscita',
  'Nothing to export': 'Niente da esportare',
  'Select all': 'Seleziona tutto',
  'Select task': 'Seleziona attività',
  '{n} selected': '{n} selezionate',
  'Set status…': 'Imposta stato…',
  'Assign to…': 'Assegna a…',
  'Clear selection': 'Deseleziona',
  'Updated {n} tasks': 'Aggiornate {n} attività',
  'Email': 'Email',
  'Phone': 'Telefono',
  'Month': 'Mese',
  'Agenda': 'Agenda',
  'Today': 'Oggi',
  'Previous': 'Precedente',
  'Next': 'Successivo',
  'No events this month.': 'Nessun evento in questo mese.',
  'No dated tasks to show on the timeline. Add start and due dates to tasks.':
    'Nessuna attività datata da mostrare sulla timeline. Aggiungi date di inizio e scadenza.',
  'Fit': 'Adatta',
  '{n} dated tasks': '{n} attività datate',
  'Drag a task onto a day to reschedule': 'Trascina un\'attività su un giorno per riprogrammarla',
  'Drag to reschedule': 'Trascina per riprogrammare',
  'Dates updated': 'Date aggiornate',
  'Could not update dates': 'Impossibile aggiornare le date',
  'Workspace': 'Area di lavoro',
  'Trade': 'Trade',
  'Key deadlines from tasks and contracts — open the calendar for the full schedule.':
    'Scadenze chiave da attività e contratti — apri il calendario per la pianificazione completa.',
  'Fund client': 'Cliente fondo',
  'All fund clients': 'Tutti i clienti fondo',
  'Task': 'Attività',
  'Project': 'Progetto',
  'Assignee': 'Assegnatario',
  'Priority': 'Priorità',
  'Status': 'Stato',
  'Due': 'Scadenza',
  '{n}d overdue': 'in ritardo di {n}g',
  'today': 'oggi',
  'in {n}d': 'tra {n}g',
  'Title': 'Titolo',
  'Description': 'Descrizione',
  'Start date': 'Data inizio',
  'Due date': 'Scadenza',
  'Checklist': 'Lista di controllo',
  'Add a checklist item…': 'Aggiungi un elemento…',
  'Items are saved together with the task.': "Gli elementi vengono salvati insieme all'attività.",
  'Remove': 'Rimuovi',
  'New task': 'Nuova attività',
  'Edit task': 'Modifica attività',
  'Task created': 'Attività creata',
  'Task saved': 'Attività salvata',
  'Delete task': 'Elimina attività',
  'Delete this task?': "Eliminare questa attività?",
  'Task deleted': 'Attività eliminata',

  // Companies
  'New company': 'Nuova azienda',
  'Search name or contact…': 'Cerca per nome o contatto…',
  'All types': 'Tutti i tipi',
  'No companies yet. Add the first one with "New company".': 'Nessuna azienda. Aggiungine una con "Nuova azienda".',
  'Name': 'Nome',
  'Type': 'Tipo',
  'Country': 'Paese',
  'Contact': 'Contatto',
  'Email': 'Email',
  'Phone': 'Telefono',
  'Contact name': 'Nome contatto',
  'Contact email': 'Email contatto',
  'Contact phone': 'Telefono contatto',
  'Notes': 'Note',
  'Specialties / categories': 'Specialità / categorie',
  'No categories yet — add some in Settings': 'Nessuna categoria — aggiungine in Impostazioni',
  'New company': 'Nuova azienda',
  'Edit company': 'Modifica azienda',
  'Company created': 'Azienda creata',
  'Company saved': 'Azienda salvata',
  'Delete company': 'Elimina azienda',
  'Delete this company?': 'Eliminare questa azienda?',
  'Company deleted': 'Azienda eliminata',

  // Projects
  'New project': 'Nuovo progetto',
  'Search project name…': 'Cerca per nome progetto…',
  'All statuses': 'Tutti gli stati',
  'No projects yet.': 'Nessun progetto.',
  'Manufacturers': 'Produttori',
  'Clients': 'Clienti',
  'Commission': 'Provvigione',
  'Deadline': 'Scadenza',
  'Edit project': 'Modifica progetto',
  'Our company': 'Nostra azienda',
  'Exclusivity': 'Esclusiva',
  'Gross / Net (€)': 'Lordo / Netto (€)',
  'Contract': 'Contratto',
  'Add contract': 'Aggiungi contratto',
  'No contracts.': 'Nessun contratto.',
  'expires': 'scade il',
  'Add task': 'Aggiungi attività',
  'No tasks.': 'Nessuna attività.',
  'Sub-projects': 'Sotto-progetti',
  'New sub-project': 'Nuovo sotto-progetto',
  'No sub-projects.': 'Nessun sotto-progetto.',
  'Files': 'File',
  'Project created': 'Progetto creato',
  'Project saved': 'Progetto salvato',
  'Delete project': 'Elimina progetto',
  'Delete this project and everything linked to it (contracts, tasks, files)?': 'Eliminare questo progetto e tutto ciò che è collegato (contratti, attività, file)?',
  'Project deleted': 'Progetto eliminato',
  'Could not load companies — the edit form may show empty dropdowns. Reload to retry.': 'Impossibile caricare le aziende — i menu a tendina potrebbero risultare vuoti. Ricarica per riprovare.',
  'Could not load users — the edit form may show empty dropdowns. Reload to retry.': 'Impossibile caricare gli utenti — i menu a tendina potrebbero risultare vuoti. Ricarica per riprovare.',
  'Parent project (for a sub-project)': 'Progetto principale (per un sotto-progetto)',
  'No client companies': 'Nessuna azienda cliente',
  'No manufacturer companies': 'Nessuna azienda produttrice',
  '— None (top-level) —': '— Nessuno (livello superiore) —',
  '— None —': '— Nessuno —',
  'Gross value (€)': 'Valore lordo (€)',
  'Net collected (€)': 'Netto incassato (€)',
  'Commission % override': 'Provvigione % personalizzata',
  '{pct}% of net': '{pct}% del netto',
  'override': 'personalizzata',
  'from exclusivity': "dall'esclusiva",

  // Contracts
  'New contract': 'Nuovo contratto',
  'Value': 'Valore',
  'Expires': 'Scade',
  'No contracts yet.': 'Nessun contratto.',
  'Value (EUR)': 'Valore (EUR)',
  'Start': 'Inizio',
  'Signed': 'Firmato',
  'Expiry': 'Scadenza',
  'Files (versioned)': 'File (con versioni)',
  'Upload file': 'Carica file',
  'No files uploaded.': 'Nessun file caricato.',
  'Contract created': 'Contratto creato',
  'Contract saved': 'Contratto salvato',
  'Delete contract': 'Elimina contratto',
  'Delete this contract and its files?': 'Eliminare questo contratto e i suoi file?',
  'Contract deleted': 'Contratto eliminato',

  // Funds / fund clients / SAL
  'New fund': 'Nuovo bando',
  'Search name or reference code…': 'Cerca per nome o codice di riferimento…',
  'Fund': 'Bando',
  'Body': 'Ente',
  'Budget': 'Budget',
  'Closes': 'Chiude',
  'No funds yet.': 'Nessun bando.',
  'Edit fund': 'Modifica bando',
  'Funding body': 'Ente erogatore',
  'Programme': 'Programma',
  'Reference': 'Riferimento',
  'Total budget': 'Budget totale',
  'Window': 'Finestra',
  'Enrolled clients': 'Clienti iscritti',
  'Enroll client': 'Iscrivi cliente',
  'No clients enrolled yet. Use "Enroll client" to add the first one.': 'Nessun cliente iscritto. Usa "Iscrivi cliente" per aggiungerne uno.',
  'requested': 'richiesto',
  'approved': 'approvato',
  '{n} milestones': '{n} milestone',
  'Master documents (templates)': 'Documenti master (modelli)',
  'Fund created': 'Bando creato',
  'Fund saved': 'Bando salvato',
  'Delete fund': 'Elimina bando',
  'Delete this fund and all client enrollments, milestones and documents under it?': 'Eliminare questo bando e tutte le iscrizioni, milestone e documenti collegati?',
  'Fund deleted': 'Bando eliminato',
  'Our company (entity handling this fund)': 'Nostra azienda (che gestisce questo bando)',
  'Programme / measure': 'Programma / misura',
  'Reference code': 'Codice di riferimento',
  'Total budget (€)': 'Budget totale (€)',
  'Opens': 'Apre',

  'Grant requested': 'Contributo richiesto',
  'Grant approved': 'Contributo approvato',
  'Our fee': 'Nostro compenso',
  'Submitted': 'Presentato',
  'Approved': 'Approvato',
  'Edit details': 'Modifica dettagli',
  'Copy from fund templates': 'Copia dai modelli del bando',
  'No master templates on this fund yet.': 'Nessun modello master su questo bando.',
  'no file': 'nessun file',
  'Copy to client': 'Copia al cliente',
  'Copying…': 'Copia in corso…',
  'Document copied to client': 'Documento copiato al cliente',
  'Client documents': 'Documenti del cliente',
  'Payment milestones (SAL)': 'Milestone di pagamento (SAL)',
  'Add milestone': 'Aggiungi milestone',
  'No payment milestones yet. Use "Add milestone" to plan the first one.': 'Nessuna milestone. Usa "Aggiungi milestone" per pianificarne una.',
  'planned': 'previsto',
  'paid': 'pagato',
  'Generate tasks': 'Genera attività',
  'Create the standard checklist of tasks for this payment milestone?': 'Creare la lista di attività standard per questa milestone di pagamento?',
  '1 task created': '1 attività creata',
  '{n} tasks created': '{n} attività create',
  'Enroll client': 'Iscrivi cliente',
  'Edit enrollment': 'Modifica iscrizione',
  'Client': 'Cliente',
  'Grant requested (€)': 'Contributo richiesto (€)',
  'Grant approved (€)': 'Contributo approvato (€)',
  'Our fee %': 'Nostro compenso %',
  'Our fee (€, override)': 'Nostro compenso (€, personalizzato)',
  'Submitted on': 'Presentato il',
  'Approved on': 'Approvato il',
  'Client enrolled': 'Cliente iscritto',
  'Enrollment saved': 'Iscrizione salvata',
  'Remove enrollment': 'Rimuovi iscrizione',
  'Remove this client enrollment and everything under it (documents, milestones, tasks)?': 'Rimuovere questa iscrizione e tutto ciò che è collegato (documenti, milestone, attività)?',
  'Enrollment removed': 'Iscrizione rimossa',
  'Milestone #': 'Milestone n.',
  'Milestone created': 'Milestone creata',
  'Milestone saved': 'Milestone salvata',
  'Delete milestone': 'Elimina milestone',
  'Delete this payment milestone?': 'Eliminare questa milestone di pagamento?',
  'Milestone deleted': 'Milestone eliminata',
  'New payment milestone': 'Nuova milestone di pagamento',
  'Edit payment milestone': 'Modifica milestone di pagamento',
  'Planned date': 'Data prevista',
  'Planned amount (€)': 'Importo previsto (€)',
  'Paid': 'Pagato',
  'Paid amount (€)': 'Importo pagato (€)',
  'e.g. SAL 1 — 30% progress': 'es. SAL 1 — 30% avanzamento',

  // Exclusivities
  'New exclusivity': 'Nuova esclusiva',
  'No exclusivity agreements yet.': 'Nessun accordo di esclusiva.',
  'Scope': 'Ambito',
  'Ends': 'Termina',
  'Client': 'Cliente',
  'Territory': 'Territorio',
  'Brand': 'Marchio',
  'Exclusivity created': 'Esclusiva creata',
  'Exclusivity saved': 'Esclusiva salvata',
  'Delete exclusivity': 'Elimina esclusiva',
  'Delete this exclusivity? Linked projects keep their data but lose the link.': "Eliminare questa esclusiva? I progetti collegati mantengono i dati ma perdono il collegamento.",
  'Exclusivity deleted': 'Esclusiva eliminata',
  'Brand / manufacturer (optional)': 'Marchio / produttore (opzionale)',
  'Default commission %': 'Provvigione predefinita %',
  'End / expiry': 'Fine / scadenza',

  // Calendar
  'Contract expiries': 'Scadenze contratti',
  'Payment milestones': 'Milestone di pagamento',

  // Account / Users / Settings
  'Current password': 'Password attuale',
  'New password': 'Nuova password',
  'Confirm new password': 'Conferma nuova password',
  'Update password': 'Aggiorna password',
  'New passwords do not match': 'Le nuove password non coincidono',
  'New password must be at least 8 characters': 'La nuova password deve avere almeno 8 caratteri',
  'Password updated.': 'Password aggiornata.',
  'Could not change password': 'Impossibile cambiare la password',
  'Change password': 'Cambia password',
  'Role': 'Ruolo',
  'New user': 'Nuovo utente',
  'No users.': 'Nessun utente.',
  'Active': 'Attivo',
  'Disabled': 'Disabilitato',
  'Password': 'Password',
  'Reset password (leave blank to keep)': 'Reimposta password (lascia vuoto per mantenere)',
  'Edit {name}': 'Modifica {name}',
  'Manage the classification categories used across companies and projects.': 'Gestisci le categorie di classificazione usate per aziende e progetti.',
  'None yet.': 'Ancora nessuna.',
  'Add new…': 'Aggiungi nuovo…',
  'Delete category': 'Elimina categoria',
  'Delete this category? It will be removed from any company/project using it.': "Eliminare questa categoria? Verrà rimossa da tutte le aziende/progetti che la usano.",

  // AI settings
  'AI assistant': 'Assistente AI',
  'Keys are stored on the server and never sent back to the browser.': 'Le chiavi sono conservate sul server e non vengono mai inviate al browser.',
  'Active provider': 'Provider attivo',
  'Autonomy (how the assistant may act)': "Autonomia (come può agire l'assistente)",
  'Read-only — no changes, ever': 'Sola lettura — nessuna modifica, mai',
  'Approval required — you confirm every action (recommended)': 'Approvazione richiesta — confermi ogni azione (consigliato)',
  'Non-destructive auto — creates/updates run, deletes need approval': 'Automatico non distruttivo — crea/aggiorna in autonomia, le eliminazioni richiedono approvazione',
  'Full access — runs everything automatically': 'Accesso completo — esegue tutto automaticamente',
  'Write tools below must also be enabled. All AI changes are grouped into restore points you can undo.': 'Anche gli strumenti di scrittura qui sotto devono essere abilitati. Tutte le modifiche AI sono raggruppate in punti di ripristino annullabili.',
  'key set': 'chiave impostata',
  'no key': 'nessuna chiave',
  'Base URL (OpenAI-compatible)': 'URL base (compatibile OpenAI)',
  'Model': 'Modello',
  '(leave blank to keep)': '(lascia vuoto per mantenere)',
  'Multimodal & voice': 'Multimodale e voce',
  'Authorized tools': 'Strumenti autorizzati',
  'Grant full access (all tools + full autonomy)': 'Concedi accesso completo (tutti gli strumenti + autonomia totale)',
  'Enable all tools': 'Abilita tutti gli strumenti',
  'Disable all': 'Disabilita tutti',
  '“Grant full access” turns on every tool and sets autonomy to Full — the AI will create, update and act automatically. Remember to click Save below. All changes remain undoable via restore points.': '"Concedi accesso completo" attiva tutti gli strumenti e imposta l\'autonomia su Completa — l\'AI creerà, aggiornerà e agirà automaticamente. Ricorda di cliccare Salva. Tutte le modifiche restano annullabili tramite i punti di ripristino.',
  'Extra system instructions (optional)': 'Istruzioni di sistema aggiuntive (opzionale)',
  'Save AI settings': 'Salva impostazioni AI',
  'AI settings saved.': 'Impostazioni AI salvate.',

  // Documents
  'Trash': 'Cestino',
  'Back to documents': 'Torna ai documenti',
  'Add template': 'Aggiungi modello',
  'Add document': 'Aggiungi documento',
  'Trash is empty.': 'Il cestino è vuoto.',
  'No documents.': 'Nessun documento.',
  'no file': 'nessun file',
  'Delete permanently': 'Elimina definitivamente',
  'Versions': 'Versioni',
  'History': 'Cronologia',
  'Move to trash': 'Sposta nel cestino',
  'Move "{title}" to trash? Versions are kept and it can be restored.': 'Spostare "{title}" nel cestino? Le versioni vengono mantenute e potrà essere ripristinato.',
  'Permanently delete "{title}" and its files? This cannot be undone.': 'Eliminare definitivamente "{title}" e i suoi file? L\'operazione non può essere annullata.',
  'Choose a file to upload.': 'Scegli un file da caricare.',
  'Add master template': 'Aggiungi modello master',
  'Title (optional — defaults to filename)': 'Titolo (opzionale — di default il nome del file)',
  'Type / label (optional)': 'Tipo / etichetta (opzionale)',
  'File': 'File',
  'Note (optional)': 'Nota (opzionale)',
  'Uploading…': 'Caricamento…',
  'Choose the filled file to upload.': 'Scegli il file compilato da caricare.',
  'Restore version': 'Ripristina versione',
  'Restore v{n} as the current version? (history is preserved)': 'Ripristinare v{n} come versione corrente? (la cronologia viene mantenuta)',
  'No versions yet.': 'Ancora nessuna versione.',
  'Delete document': 'Elimina documento',
  'Upload new version': 'Carica nuova versione',
  'Filled file': 'File compilato',
  'Note (what changed)': 'Nota (cosa è cambiato)',
  'Add version': 'Aggiungi versione',

  // Login
  'Login failed': 'Accesso non riuscito',
  'Project & contract management': 'Gestione progetti e contratti',
  'you@company.com': 'tu@azienda.com',
  'Sign in': 'Accedi',
  'Signing in…': 'Accesso in corso…',
  'Forgot your password? Contact your administrator to reset it.': 'Password dimenticata? Contatta il tuo amministratore per reimpostarla.',

  // Offline / errors
  'You’re offline — changes may not be saved until your connection returns.': 'Sei offline — le modifiche potrebbero non essere salvate finché la connessione non torna.',

  // File viewer
  'No inline preview for “.{ext}” files. Use Download.': 'Nessuna anteprima per i file “.{ext}”. Usa Scarica.',
  '(Tip: convert this older format to .docx to preview it directly in the app.)': '(Suggerimento: converti questo formato in .docx per vederne l\'anteprima direttamente nell\'app.)',

  // Event detail modal
  '{type} details': 'Dettagli {type}',
  'Go to details': 'Vai ai dettagli',
  'Fund / body': 'Bando / ente',
  'Planned amount': 'Importo previsto',
  'Date': 'Data',

  // Assistant
  'New chat': 'Nuova conversazione',
  'No conversations yet.': 'Nessuna conversazione.',
  'Untitled': 'Senza titolo',
  'Rename conversation': 'Rinomina conversazione',
  'Delete conversation': 'Elimina conversazione',
  'Delete this conversation and its history?': 'Eliminare questa conversazione e la sua cronologia?',
  'Restore points': 'Punti di ripristino',
  'Not configured': 'Non configurato',
  'Powered by {provider}': 'Basato su {provider}',
  'AI autonomy level': 'Livello di autonomia AI',
  'The AI assistant isn’t configured yet.': "L'assistente AI non è ancora configurato.",
  'Set a provider, model and API key in': 'Imposta un provider, modello e chiave API in',
  'Ask an admin to set it up in Settings.': 'Chiedi a un amministratore di configurarlo in Impostazioni.',
  'Drop images, PDFs or documents to attach': 'Trascina qui immagini, PDF o documenti da allegare',
  'Ask about funds, payment milestones, fund clients, projects, contracts, tasks, exclusivities or commissions.': 'Chiedi informazioni su bandi, milestone di pagamento, clienti, progetti, contratti, attività, esclusive o provvigioni.',
  'Older messages were summarized to keep the chat fast.': 'I messaggi più vecchi sono stati riassunti per mantenere la chat veloce.',
  'used': 'usati',
  'Play': 'Riproduci',
  '▶ playing…': '▶ in riproduzione…',
  'Thinking…': 'Sto pensando…',
  '1 action awaiting your approval': '1 azione in attesa della tua approvazione',
  '{n} actions awaiting your approval': '{n} azioni in attesa della tua approvazione',
  'Approve all': 'Approva tutte',
  'No text could be extracted (maybe scanned)': 'Non è stato possibile estrarre testo (forse è una scansione)',
  'no text': 'nessun testo',
  'Attach images or PDFs/docs': 'Allega immagini o PDF/documenti',
  'Stop recording': 'Ferma registrazione',
  'Record voice': 'Registra voce',
  'Listening… tap stop when done': 'In ascolto… premi stop quando hai finito',
  'Ask the assistant…': "Scrivi all'assistente…",
  'Send': 'Invia',
  'Working… {n} step(s)': 'In corso… {n} passaggi',
  'Stopped. The assistant may not have finished its task.': "Fermato. L'assistente potrebbe non aver completato il compito.",
  'The assistant stopped after 40 steps without finishing. Ask it to continue if needed.': "L'assistente si è fermato dopo 40 passaggi senza finire. Chiedigli di continuare se necessario.",
  'The assistant could not respond.': "L'assistente non ha potuto rispondere.",
  'Microphone not available or permission denied.': 'Microfono non disponibile o permesso negato.',
  'Undo "{label}"? This reverts {n} change(s).': 'Annullare "{label}"? Verranno annullate {n} modifiche.',
  'Which payment milestones are due in the next 30 days?': 'Quali milestone di pagamento scadono nei prossimi 30 giorni?',
  'List fund clients still in "preparing" status.': 'Elenca i clienti su bandi ancora in stato "in preparazione".',
  'Which contracts expire in the next 30 days?': 'Quali contratti scadono nei prossimi 30 giorni?',
  'Summarise active projects and their commissions.': 'Riepiloga i progetti attivi e le loro provvigioni.',

  // Territory / country literals used as option values
  'Italy': 'Italia',
  'Morocco': 'Marocco',
  'Other': 'Altro',

  // AI autonomy short labels (used via AUTONOMY_LABEL map values)
  'read-only': 'sola lettura',
  'approval required': 'approvazione richiesta',
  'auto (non-destructive)': 'automatico (non distruttivo)',
  'full access': 'accesso completo',

  // Roles / enum values (shared via enumLabel / t on raw db values)
  'admin': 'amministratore',
  'manager': 'responsabile',
  'partner': 'partner',
  'active': 'attivo',
  'disabled': 'disabilitato',

  // Task/status/priority enum values (also covered by enumLabel in i18n/index.jsx,
  // duplicated here for direct t(status) call sites)
  'To do': 'Da fare',
  'In progress': 'In corso',
  'Blocked': 'Bloccato',
  'Review': 'Da rivedere',
  'Done': 'Fatto',
  'Lead': 'Potenziale',
  'On hold': 'In pausa',
  'Completed': 'Completato',
  'Cancelled': 'Annullato',
  'Preparing': 'In preparazione',
  'Submitted': 'Presentato',
  'Rejected': 'Rifiutato',
  'Draft': 'Bozza',
  'Sent': 'Inviato',
  'Expired': 'Scaduto',
  'Scouting': 'In valutazione',
  'Reporting': 'Rendicontazione',
  'Closed': 'Chiuso',
  'To fill': 'Da compilare',
  'Filled': 'Compilato',
  'Planned': 'Previsto',
  'Low': 'Bassa',
  'Medium': 'Media',
  'High': 'Alta',
  'Urgent': 'Urgente',
  'Manufacturer': 'Produttore',
  'Our company': 'Nostra azienda',

  // AI tool names (Settings page)
  'Search projects': 'Cerca progetti',
  'Read a project (full detail)': 'Leggi un progetto (dettaglio completo)',
  'List tasks / overdue': 'Elenca attività / in ritardo',
  'List contracts / expiring': 'Elenca contratti / in scadenza',
  'List exclusivities': 'Elenca esclusive',
  'List companies': 'Elenca aziende',
  'Dashboard summary': 'Riepilogo dashboard',
  'List funds (bandi)': 'Elenca bandi',
  'Read a fund (full detail)': 'Leggi un bando (dettaglio completo)',
  'List fund clients': 'Elenca clienti su bandi',
  'List SAL milestones due': 'Elenca milestone SAL in scadenza',
  'List documents': 'Elenca documenti',
  'Read document text (PDF/DOCX/TXT)': 'Leggi il testo di un documento (PDF/DOCX/TXT)',
  'OCR scanned docs/images (vision)': 'OCR su scansioni/immagini (visione)',
  'Fetch web page text': 'Recupera il testo di una pagina web',
  'Create tasks (write action)': 'Crea attività (azione di scrittura)',
  'Update tasks (write action)': 'Aggiorna attività (azione di scrittura)',
  'Create projects (write action)': 'Crea progetti (azione di scrittura)',
  'Update projects (write action)': 'Aggiorna progetti (azione di scrittura)',
  'Create companies (write action)': 'Crea aziende (azione di scrittura)',
  'Update companies (write action)': 'Aggiorna aziende (azione di scrittura)',
  'Create contracts (write action)': 'Crea contratti (azione di scrittura)',
  'Create funds / bandi (write action)': 'Crea bandi (azione di scrittura)',
  'Update funds (write action)': 'Aggiorna bandi (azione di scrittura)',
  'Enroll fund clients (write action)': 'Iscrivi clienti a bandi (azione di scrittura)',
  'Create SAL milestones (write action)': 'Crea milestone SAL (azione di scrittura)',

  // Two-factor authentication
  'Disable': 'Disattiva',
  'Two-factor authentication': "Autenticazione a due fattori",
  'Enable two-factor authentication': 'Attiva autenticazione a due fattori',
  'Disable two-factor authentication': 'Disattiva autenticazione a due fattori',
  'Two-factor authentication is enabled on your account.': 'L\'autenticazione a due fattori è attiva sul tuo account.',
  'Two-factor authentication enabled': 'Autenticazione a due fattori attivata',
  'Two-factor authentication disabled': 'Autenticazione a due fattori disattivata',
  'Are you sure? Your account will only be protected by your password.': 'Sei sicuro? Il tuo account sarà protetto solo dalla password.',
  'Add an extra layer of security: after your password, you will also need a 6-digit code from an authenticator app.': 'Aggiungi un livello di sicurezza in più: dopo la password ti servirà anche un codice a 6 cifre da un\'app di autenticazione.',
  'Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password…), then enter the 6-digit code it shows.': 'Scansiona questo codice QR con la tua app di autenticazione (Google Authenticator, Authy, 1Password…), poi inserisci il codice a 6 cifre mostrato.',
  'Or enter this code manually:': 'Oppure inserisci questo codice manualmente:',
  '6-digit code': 'Codice a 6 cifre',
  'Confirm and enable': 'Conferma e attiva',
  'Save these recovery codes somewhere safe — each one can be used once if you lose access to your authenticator app. They will not be shown again.': 'Salva questi codici di ripristino in un posto sicuro — ognuno può essere usato una sola volta se perdi l\'accesso alla tua app di autenticazione. Non verranno mostrati di nuovo.',
  'Done': 'Fatto',
  'Enter the code from your authenticator app': "Inserisci il codice dalla tua app di autenticazione",
  'Authentication code': 'Codice di autenticazione',
  'Recovery code': 'Codice di ripristino',
  'Use a recovery code instead': 'Usa invece un codice di ripristino',
  'Use authenticator code instead': 'Usa invece il codice dell\'app',
  'Verify': 'Verifica',
  'Verifying…': 'Verifica in corso…',
  'Invalid code': 'Codice non valido',
  'Two-factor authentication is required for your role': 'L\'autenticazione a due fattori è obbligatoria per il tuo ruolo',
  'set it up on your Account page': 'attivala nella pagina Account',
  'Set up now': 'Attiva ora',
  'Two-factor authentication policy': 'Politica di autenticazione a due fattori',
  'Users with these roles will be prompted to set up two-factor authentication on their Account page. This is a nudge, not a hard block — existing sessions are not interrupted.': 'Gli utenti con questi ruoli riceveranno un promemoria per attivare l\'autenticazione a due fattori nella pagina Account. È un suggerimento, non un blocco — le sessioni esistenti non vengono interrotte.',
  'Two-factor policy saved': 'Politica salvata',

  // Telegram
  'Telegram': 'Telegram',
  'Unlink': 'Scollega',
  'Unlink Telegram': 'Scollega Telegram',
  'Stop this Telegram account from receiving bot replies and reminders?': 'Interrompere l\'invio di risposte e promemoria del bot a questo account Telegram?',
  'Telegram unlinked': 'Telegram scollegato',
  'Your Telegram account is linked. Message the bot with /help to see available commands.': 'Il tuo account Telegram è collegato. Scrivi /help al bot per vedere i comandi disponibili.',
  'Open Telegram, message': 'Apri Telegram, scrivi a',
  'the bot': 'il bot',
  'and send:': 'e invia:',
  'This code expires in {n} minutes.': 'Questo codice scade tra {n} minuti.',
  'Link Telegram to get due-date and balance lookups from your phone (/due, /balance, /project). Read-only — no changes can be made via chat.': 'Collega Telegram per controllare scadenze e saldi dal telefono (/due, /balance, /project). Solo lettura — nessuna modifica può essere fatta via chat.',
  'Generate link code': 'Genera codice di collegamento',

  // Conversations
  'Call': 'Chiamata',
  'Meeting': 'Riunione',
  'Note': 'Nota',
  'Conversations': 'Conversazioni',
  'Log conversation': 'Registra conversazione',
  'Log a conversation': 'Registra una conversazione',
  'Edit conversation': 'Modifica conversazione',
  'When': 'Quando',
  'Summary': 'Riepilogo',
  'What was discussed / agreed…': 'Cosa è stato discusso / concordato…',
  'No conversations logged.': 'Nessuna conversazione registrata.',
  'Conversation logged': 'Conversazione registrata',
  'Conversation saved': 'Conversazione salvata',
  'Conversation deleted': 'Conversazione eliminata',
  'Delete conversation record': 'Elimina conversazione',
  'Delete this conversation and its attachments?': 'Eliminare questa conversazione e i suoi allegati?',
  'Attachments': 'Allegati',
  'Add attachment': 'Aggiungi allegato',
  'No attachments.': 'Nessun allegato.',
  'Transcribe': 'Trascrivi',
  'Transcribed': 'Trascritto',
  'Transcribing…': 'Trascrizione in corso…',
  'Transcription ready': 'Trascrizione pronta',

  // Logos & addresses (wave 9)
  'Logo': 'Logo',
  'No logo': 'Nessun logo',
  'Upload logo': 'Carica logo',
  'Replace logo': 'Sostituisci logo',
  'Remove logo': 'Rimuovi logo',
  'Remove this company\'s logo?': 'Rimuovere il logo di questa azienda?',
  'Logo updated': 'Logo aggiornato',
  'Logo removed': 'Logo rimosso',
  'Address (printed on invoices, multiline)': 'Indirizzo (stampato sulle fatture, multi-riga)',
  'Street\nPostal code, City\nCountry': 'Via\nCAP, Città\nPaese',
  'Subtitle (optional — printed under the title)': 'Sottotitolo (opzionale — stampato sotto il titolo)',
  'Bill to (client or manufacturer)': 'Fatturare a (cliente o produttore)',
  'Select a company…': 'Seleziona un\'azienda…',
  'Search companies…': 'Cerca aziende…',
  'No matches': 'Nessun risultato',

  // Client 360 / warnings
  'Total invoiced': 'Totale fatturato',
  'No projects linked to this company.': 'Nessun progetto collegato a questa azienda.',
  'Warnings': 'Avvisi',
  'Add warning': 'Aggiungi avviso',
  'No warnings recorded.': 'Nessun avviso registrato.',
  'Severity': 'Gravità',
  'Message': 'Messaggio',
  'Info': 'Info',
  'Warning': 'Avviso',
  'Critical': 'Critico',
  'Resolve': 'Risolvi',
  'Delete warning': 'Elimina avviso',
  'Delete this warning?': 'Eliminare questo avviso?',
  'Warning added': 'Avviso aggiunto',
  'Warning resolved': 'Avviso risolto',
  'Warning deleted': 'Avviso eliminato',

  // General business line (wave 10)
  'General': 'Generale',
  'General — internal initiatives': 'Generale — iniziative interne',
  'Initiative': 'Iniziativa',
  'Initiatives': 'Iniziative',
  'New initiative': 'Nuova iniziativa',
  'Edit initiative': 'Modifica iniziativa',
  'No initiatives yet.': 'Nessuna iniziativa.',
  'All initiatives': 'Tutte le iniziative',
  'Active initiatives': 'Iniziative attive',
  'UAE': 'Emirati Arabi Uniti',

  // Project tabs
  'Overview': 'Panoramica',
  'Offers & contracts': 'Offerte e contratti',

  // Offers
  'Offers': 'Offerte',
  'New offer': 'Nuova offerta',
  'Add offer': 'Aggiungi offerta',
  'Delete offer': 'Elimina offerta',
  'Delete this offer and its files?': 'Eliminare questa offerta e i suoi file?',
  'Offer created': 'Offerta creata',
  'Offer saved': 'Offerta salvata',
  'Offer deleted': 'Offerta eliminata',
  'No offers.': 'Nessuna offerta.',
  'No offers yet.': 'Nessuna offerta.',
  'Valid until': 'Valida fino al',
  'Accept': 'Accetta',
  'Accept offer': "Accetta offerta",
  'Accept → create contract': 'Accetta → crea contratto',
  'Accept this offer and create a linked contract draft from it?': 'Accettare questa offerta e creare una bozza di contratto collegata?',
  'Offer accepted — contract draft created': 'Offerta accettata — bozza di contratto creata',
  'Accepted — linked contract: {title}': 'Accettata — contratto collegato: {title}',
  'Negotiating': 'In negoziazione',
  'Accepted': 'Accettata',

  // Contract signing
  'Mark as signed': 'Segna come firmato',
  'Mark this version as the signed contract? The contract status will move to Signed.': 'Segnare questa versione come contratto firmato? Lo stato passerà a Firmato.',
  'Contract marked as signed': 'Contratto segnato come firmato',
  'Signed copy': 'Copia firmata',

  // Invoices
  'Invoices': 'Fatture',
  'New invoice': 'Nuova fattura',
  'Edit invoice': 'Modifica fattura',
  'Delete invoice': 'Elimina fattura',
  'Delete this invoice and its payment history?': 'Eliminare questa fattura e lo storico dei pagamenti?',
  'Invoice created': 'Fattura creata',
  'Invoice saved': 'Fattura salvata',
  'Invoice deleted': 'Fattura eliminata',
  'No invoices yet.': 'Nessuna fattura.',
  'Number': 'Numero',
  'Amount': 'Importo',
  'Balance due': 'Saldo dovuto',
  'Issued': 'Emessa il',
  'Issue date': 'Data di emissione',
  'Due date (optional)': 'Scadenza (opzionale)',
  'Place': 'Luogo',
  'Currency': 'Valuta',
  'Our company (emitter)': 'Nostra azienda (emittente)',
  'Project (optional)': 'Progetto (opzionale)',
  'Attention of (optional)': "All'attenzione di (opzionale)",
  'Reference (purchase order, CMS ref…)': 'Riferimento (ordine, rif. CMS…)',
  'Base amount HT': 'Importo base HT',
  'Commission rate %': 'Percentuale commissione %',
  'Apply a tranche (partial commission on a % of the base amount)': 'Applica una tranche (commissione parziale su una % del base)',
  'Tranche %': 'Tranche %',
  'Tranche description': 'Descrizione tranche',
  'e.g. Tranche 1 (30% deposit)': 'es. Tranche 1 (acconto 30%)',
  'Description (optional — auto-generated if left blank)': 'Descrizione (opzionale — generata automaticamente se vuota)',
  'Number (optional — auto-generated if left blank)': 'Numero (opzionale — generato automaticamente se vuoto)',
  'VAT / legal note (optional)': 'Nota IVA / legale (opzionale)',
  'Internal notes (optional)': 'Note interne (opzionale)',
  'Print / PDF': 'Stampa / PDF',
  'Print / Save as PDF': 'Stampa / Salva come PDF',
  'Payments': 'Pagamenti',
  'Record payment': 'Registra pagamento',
  'Record a payment': 'Registra un pagamento',
  'No payments recorded yet.': 'Nessun pagamento registrato.',
  'Payer': 'Pagatore',
  'Method (optional)': 'Metodo (opzionale)',
  'bank transfer, cash…': 'bonifico, contanti…',
  'Payment recorded': 'Pagamento registrato',
  'Payment deleted': 'Pagamento eliminato',
  'Delete payment': 'Elimina pagamento',
  'Delete this payment record?': 'Eliminare questo pagamento?',

  // Company invoicing details
  'Invoicing details (optional)': 'Dati di fatturazione (opzionale)',
  'Tax ID / P.IVA / ICE': 'P.IVA / ICE',
  'RC (trade register)': 'RC (registro di commercio)',
  'Tribunal': 'Tribunale',
  'Share capital': 'Capitale sociale',
  'Legal representative': 'Rappresentante legale',
  'Representative role': 'Ruolo del rappresentante',
  'Bank name': 'Banca',
  'IBAN': 'IBAN',
  'SWIFT / BIC': 'SWIFT / BIC',
  'Account holder': 'Intestatario',

  // Phases
  'Phases': 'Fasi',
  'Phase saved': 'Fase salvata',
  'Label (EN)': 'Etichetta (EN)',
  'Label (IT)': 'Etichetta (IT)',
  'Started': 'Iniziata',
  'Ended': 'Conclusa',
  'Pending': 'In attesa',
  'Skipped': 'Saltata',
  'Companies in this phase': 'Aziende in questa fase',
  'No companies added to this phase yet.': 'Nessuna azienda aggiunta a questa fase.',
  'Add a company…': 'Aggiungi un\'azienda…',
  'All countries': 'Tutti i paesi',
  'Generate': 'Genera',
  'Page {a} of {b}': 'Pagina {a} di {b}',

  // Settings category domains
  'Project types': 'Tipi di progetto',
  'e.g. FIT-in, FIT-out, Supply only': 'es. FIT-in, FIT-out, Solo fornitura',
  'Company specialties': 'Specialità azienda',
  'e.g. Lighting, Marble, Furniture': 'es. Illuminazione, Marmo, Arredamento',
};
